<template>
  <div class="card p-3 shadow-sm">
    <form @submit.prevent="addLossDetailsReport">
      <div class="row" v-if="isAllowed('accident-incident.general.edit') && isOwnVessel()">
        <div class="col-12 text-right">
          <button class="e-btn e-btn-outlined-red ml-2" type="button" v-if="toEdit" @click="cancel">Cancel
          </button>
          <button class="e-btn e-btn-green ml-2" type="button" v-else @click="editValues">Edit Loss Details</button>
          <button class="e-btn e-btn-blue ml-2" :class="hasChanges === false ? 'e-btn-blue-disabled' : ''" type="submit" v-if="toEdit" :disabled="hasChanges === false">Save</button>
        </div>
      </div>
      <table class="w-100">
        <tr>
          <td colspan="2">
            <h6 class="font-weight-bold">General</h6>
          </td>
        </tr>

        <template v-if="toEdit">
          <tr>
            <td style="width: 30%">Is Schedule Delay ?</td>
            <td>
              <select name="sched_delay"  v-model="lossDetails.is_delay_schedule" class="form-control w-auto form-control-sm my-2">
                <option :value="1">YES</option>
                <option :value="0">NO</option>
              </select>
            </td>
          </tr>
          <template  v-if="lossDetails.is_delay_schedule">
            <tr>
              <td style="width: 30%">Delay Schedule <sub class="lead e-text-red font-weight-bold">*</sub></td>
              <td>
                <!--            <input type="text" class="form-control form-control-sm" v-model="lossDetails.loss_sched_day">-->
                <div class="form-inline">
                  <div class="form-group mb-2 mr-5">
                    <label for="loss_sched_day" style="font-size: 13px" class="mr-2 font-weight-bold">Day</label>
                    <input type="number" min="0" class="form-control form-control-sm" id="loss_sched_day"
                           placeholder="Enter Day"
                           v-model="lossDetails.delay_sched_day">
                  </div>
                  <div class="form-group mx-sm-3 mb-2">
                    <label for="loss_sched_day" style="font-size: 13px" class="mr-2 font-weight-bold">Hour</label>
                    <input type="number" min="0" max="23" class="form-control form-control-sm" id="loss_sched_hour"
                           placeholder="Enter hour"
                           v-model="lossDetails.delay_sched_hour">
                  </div>

                  <div class="form-group mx-sm-3 mb-2">
                    <label for="loss_sched_day" style="font-size: 13px" class="mr-2 font-weight-bold">Minute</label>
                    <input type="number" min="0" class="form-control form-control-sm" id="loss_sched_hour" max="59"
                           placeholder="Enter minute"
                           v-model="lossDetails.delay_sched_minute">
                  </div>

                </div>
              </td>

            </tr>
            <tr>
              <td>Detail Schedule Remarks <sub class="lead e-text-red font-weight-bold">*</sub></td>
              <td v-if="toEdit">
            <textarea rows="5" class="form-control form-control-sm mb-1 pre-wrap-txt"
                      v-model="lossDetails.delay_sched_remarks"></textarea>
              </td>
            </tr>
          </template>

        </template>
        <template v-else>
          <tr>
            <td style="width: 30%">Is Schedule Delay ?</td>
            <td>
                {{ accidentIncidentReport.loss.is_delay_schedule ? 'YES' : 'NO'}}
            </td>
          </tr>
          <template v-if="accidentIncidentReport.loss.is_delay_schedule">
            <tr>
              <td style="width: 30%">Delay Schedule</td>
              <td>
                <div class="form-inline">
                  <div class="form-group mb-2 mr-5">
                    {{ accidentIncidentReport.loss.delay_sched_day ? accidentIncidentReport.loss.delay_sched_day : '0' }}
                    <span
                      class="ml-1">Day/s</span>
                  </div>

                  <div class="form-group mb-2 mr-5">
                    {{ accidentIncidentReport.loss.delay_sched_hour ? accidentIncidentReport.loss.delay_sched_hour : '0' }}
                    <span
                      class="ml-1">Hour/s</span>
                  </div>

                  <div class="form-group mb-2 mr-5">
                    {{
                      accidentIncidentReport.loss.delay_sched_minute ? accidentIncidentReport.loss.delay_sched_minute : '0'
                    }} <span
                    class="ml-1">Minute/s</span>
                  </div>

                  <div class="form-group mb-2 mr-5">
                    <span class="mr-2 font-weight-bold" style="font-size: 13px">Total:</span>
                    {{
                      setTotalHours(accidentIncidentReport.loss.delay_sched_day, accidentIncidentReport.loss.delay_sched_hour, accidentIncidentReport.loss.delay_sched_minute)
                    }} Hour/s
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td>Detail Schedule Remarks</td>
              <td>
                <p class="pre-wrap-txt textarea-display-card mb-1">
                  {{ accidentIncidentReport.loss.delay_sched_remarks }}
                </p>
              </td>
            </tr>
          </template>

        </template>

        <br>
        <br>
      </table>
      <table class="w-100">
        <tr>
          <td style="width: 30%">
            Estimated Loss Summary
          </td>
          <td>
            <p class="mb-0" v-if="accidentIncidentReport.loss.estimated_cost">
              {{ formatToMoney(accidentIncidentReport.loss.estimated_cost) }} {{ accidentIncidentReport.loss.estimated_currency }}
            </p>
          </td>
        </tr>
        <tr>
          <td style="width: 30%">
            Loss Summary
          </td>
          <td>
            <template v-for="summary in accidentIncidentReport.loss.lossSummary">
              <p class="mb-0" v-if="summary.amount">
                {{ formatToMoney(summary.amount) }} {{ summary.code }}
              </p>
            </template>
          </td>
        </tr>
      </table>

      <!--      <table class="table table-sm table-bordered small">-->
      <!--        <thead>-->
      <!--        <tr>-->
      <!--          <th class="align-middle"><h6 class="font-weight-bold mb-0">CURRENCY</h6></th>-->
      <!--          <th class="align-middle"><h6 class="font-weight-bold mb-0">TOTAL AMOUNT</h6></th>-->
      <!--        </tr>-->
      <!--        </thead>-->
      <!--        <tbody>-->
      <!--        <tr v-for="summary in accidentIncidentReport.loss.lossSummary">-->
      <!--          <template v-if="summary.amount">-->
      <!--            <td style="width: 30%"><h6 class="font-weight-bolder mb-0">{{ summary.name }} ({{ summary.code }})</h6></td>-->
      <!--            <td style="width: 80%"><h6 class="font-weight-bolder mb-0">{{ formatToMoney(summary.amount) }}</h6></td>-->
      <!--          </template>-->
      <!--        </tr>-->
      <!--        </tbody>-->
      <!--      </table>-->
      <nav class="mt-4">
        <div class="nav nav-tabs" id="nav-tab" role="tablist">
          <a class="nav-item nav-link active" id="nav-Personnel-tab" data-toggle="tab" href="#nav-Personnel" role="tab"
             :class="accidentIncidentReport.loss.personnel.length ? 'font-weight-bold bg-highlight-red' : ''"
             aria-controls="nav-Personnel" aria-selected="true">
            Personnel
          </a>
          <a class="nav-item nav-link" id="nav-HullMachinery-tab" data-toggle="tab" href="#nav-HullMachinery" role="tab"
             aria-controls="nav-HullMachinery" aria-selected="false"
             :class="accidentIncidentReport.loss.hm_cost || accidentIncidentReport.loss.hm_cost_details ? 'font-weight-bold bg-highlight-red' : ''">
            Hull and Machinery
          </a>
          <a class="nav-item nav-link" id="nav-CargoDamage-tab" data-toggle="tab" href="#nav-CargoDamage" role="tab"
             aria-controls="nav-CargoDamage" aria-selected="false"
             :class="accidentIncidentReport.loss.cd_cost || accidentIncidentReport.loss.cd_cost_details ? 'font-weight-bold bg-highlight-red' : ''">
            Cargo Damage
          </a>
          <a class="nav-item nav-link" id="nav-Environmental-tab" data-toggle="tab" href="#nav-Environmental" role="tab"
             aria-controls="nav-Environmental" aria-selected="false"
             :class="accidentIncidentReport.loss.e_cost || accidentIncidentReport.loss.e_cost_details ? 'font-weight-bold bg-highlight-red' : ''">
            Environmental
          </a>
          <a class="nav-item nav-link" id="nav-ThirdParty-tab" data-toggle="tab" href="#nav-ThirdParty" role="tab"
             aria-controls="nav-ThirdParty" aria-selected="false"
             :class="accidentIncidentReport.loss.tp_cost || accidentIncidentReport.loss.tp_cost_details ? 'font-weight-bold bg-highlight-red' : ''">
            Third Party
          </a>
        </div>
      </nav>
      <div class="tab-content pt-2" id="nav-tabContent">
        <div class="tab-pane fade show active" id="nav-Personnel" role="tabpanel" aria-labelledby="nav-Personnel-tab">
          <div>
            <div class="row mb-2">
              <div class="col-8">
                <h6 class="font-weight-bold">Personnel</h6>
              </div>
              <div class="col-4" v-if="isAllowed('accident-incident.loss.personnel.create') && isOwnVessel()">
              <div class="text-right">
                  <!--                  @click.prevent="addPersonelToList"-->
                  <!--                  v-show="toEdit"-->
                  <button type="button" class="e-btn e-btn-green" data-target="#crewPersonnel" data-toggle="modal" @click="loadLinkableMedicalReports">Add
                    Crew with Injury or Illness
                  </button>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <table class="table w-100">
                  <thead>
                  <tr>
                    <th class="text-center">RANK</th>
                    <th class="text-center">NAME</th>
                    <th class="text-center">AGE</th>
                    <th class="text-center">EMBARK DATE</th>
                    <th class="text-center">TIME ONBOARD</th>
                    <th class="text-center">MANNING</th>
                    <th class="text-center">NATIONALITY</th>
                    <th class="text-center">ACTION</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-if="isAllowed('accident-incident.loss.personnel.view')" v-for="(person,index) in personnelList" :class="person.active === false ? 'inactive-crew' : ''">
                    <td class="text-center">{{ (!!person.rank ? person.rank : '').toUpperCase() }}</td>
                    <td class="text-center">{{ (!!person.last_name ? person.last_name : '').toUpperCase() }},
                      {{ person.first_name.toUpperCase() }}
                      {{ (!!person.middle_name ? person.middle_name : '').substring(0, 1).toUpperCase() }}
                      {{ person.active === false ? '(INACTIVE)' : ''}}
                    </td>
                    <td class="text-center">{{ person.age }}</td>
                    <td class="text-center">{{ person.embarkationDate }}</td>
                    <td class="text-center">{{ person.duration }}</td>
                    <td class="text-center">{{ (person.manning ? person.manning : '').toUpperCase() }}</td>
                    <td class="text-center">{{ (person.nationality ? person.nationality : '').toUpperCase() }}</td>
                    <td class="text-center">
                      <div class="d-inline-flex align-items-center" style="gap: 0.375rem;">
                        <!-- MA-8c: only NEW accident reports connect to the KIDS v2 Medical Report. A Medical Report is
                             created on its own page and selected in "Add Crew" (user 2026-11-05), so a row only visits it. -->
                        <button v-if="isKidsV2Medical && hasKidsV2MedicalReport(person)" type="button" class="btn btn-xs btn-primary"
                                :title="'Medical report ' + kidsV2MedicalReportOf(person).number"
                                :disabled="person.medicalReportLoading"
                                @click.prevent="onMedicalReportClick(person)">
                          <font-awesome-icon icon="notes-medical" class="force-white-all"/>
                          Visit Medical Report
                        </button>
                        <!-- MA-8c: on a NEW accident report the window is read-only, so view permission is enough (PM P17). -->
                        <button v-if="isAllowed(isKidsV2Medical ? 'accident-incident.loss.personnel.view' : 'accident-incident.loss.personnel.edit')" type="button" class="btn btn-info btn-xs" data-target="#crewPersonnel"
                                data-toggle="modal" @click="viewPersonnel(person,index)">
                          <font-awesome-icon icon="eye" class="force-white-all"/>
                          View
                        </button>
                        <!-- Removing a crew with a Medical Report unlinks the report; it can be selected again (user 2026-11-05). -->
                        <button v-if="isAllowed('accident-incident.loss.personnel.delete')" class="btn btn-outline-danger btn-xs" type="button" @click.prevent="removePersonnel(person.id)">
                          <font-awesome-icon icon="trash" class="force-danger-all"/>
                        </button>
                      </div>
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </div>
            <div class="modal fade" data-backdrop="static" data-keyboard="false" tabindex="-1" id="crewPersonnel">
              <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content w-100">
                  <div class="modal-header w-100">
                    <div class="row w-100 align-items-center">
                      <div class="col-8">
                        <h5 class="modal-title" v-if="isKidsV2Medical">{{ toEditPersonnel ? 'Crew' : 'Add Crew' }}</h5>
                        <h5 class="modal-title" v-else>{{ toEditPersonnel ? 'Update ' : 'Add ' }}Personnel</h5>
                      </div>
                      <div class="col-4 text-right">
                        <button type="button" class="btn btn-xs mr-2 btn-warning" @click="updateInjuredPersonnel"
                                v-show="readOnly === false && !isKidsV2Medical">
                          Update
                        </button>
                        <button type="button" class="btn btn-xs mr-2 btn-warning" v-show="toEditPersonnel && readOnly && !isKidsV2Medical"
                                @click="readOnly=false">
                          Edit Details
                        </button>
                        <button type="button" class="btn btn-xs mr-2 btn-success" v-show="!toEditPersonnel && !isKidsV2Medical"
                                @click.prevent="addInjuredPersonnel">Add Personnel
                        </button>
                        <button class="btn btn-xs btn-secondary" type="button" data-dismiss="modal"
                                @click="resetPersonnelRecord" aria-label="Close">
                          Close
                        </button>
                      </div>
                    </div>
                  </div>
                  <div class="modal-body" style="max-height:80vh; overflow-y: auto;">
                    <!-- NEW accident report: a crew is added by selecting their Medical Report (user 2026-11-05). -->
                    <div v-if="isKidsV2Medical && !toEditPersonnel" data-field="medical-report-picker">
                      <label for="medicalReportSearch" class="font-weight-bold mb-1">Medical Report</label>
                      <input id="medicalReportSearch" type="text" @keydown.enter.prevent class="form-control form-control-sm mb-1" placeholder="Search by Medical Report no., e.g. MED2026-00018" v-model="linkableSearch">
                      <p class="small text-muted mb-2">Medical Reports of this vessel not yet linked to an accident report, dated on or after the event date, whose crew was onboard on {{ accidentIncidentReport.formatted_event_date }}.</p>
                      <p v-if="linkableLoading" class="text-muted mb-0">Loading Medical Reports...</p>
                      <p v-else-if="linkableMessage" class="text-danger mb-0" data-field="medical-report-picker-message">{{ linkableMessage }}</p>
                      <table v-else class="table table-sm table-hover w-100 mb-0">
                        <thead>
                        <tr>
                          <th>MEDICAL REPORT</th>
                          <th>REPORT DATE</th>
                          <th>CREW</th>
                          <th>STATUS</th>
                          <th></th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="report in filteredLinkableReports" :key="report.id">
                          <td class="font-weight-bold align-middle">{{ report.report_number }}</td>
                          <td class="align-middle">{{ report.report_date }}</td>
                          <td class="text-uppercase align-middle">{{ report.rank }} - {{ report.crew_name }}</td>
                          <td class="text-uppercase align-middle">{{ report.status }}</td>
                          <td class="text-right align-middle">
                            <button type="button" class="btn btn-xs btn-success" @click.prevent="selectMedicalReport(report)">Select</button>
                          </td>
                        </tr>
                        <tr v-if="!filteredLinkableReports.length">
                          <td colspan="5" class="text-center text-muted py-3">No Medical Report found.</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                    <table v-else class="w-100 mt-2">
                      <tr>
                        <td style="width: 30%">Name of Crew</td>
                        <!-- NEW accident report, viewing a crew: plain text, nothing here can be changed. -->
                        <td v-if="isKidsV2Medical && toEditPersonnel" class="py-2" data-field="crew-name">{{ crewWindowCrewLabel }}</td>
                        <td v-else>
                          <select name="selectCrewPersonnel"
                                  class="form-control form-control-sm mb-1 text-uppercase"
                                  @change="changeCrewName($event,currentIndex)"
                                  :disabled="toEditPersonnel && readOnly"
                                  v-model="personnelRecord.crew_id">
                            <option :value="null">--- SELECT CREW ---</option>
                            <option :value="crew.id" v-for="crew in crewKeys">{{ crew.rank }} - {{ !!crew ? crew.last_name.toUpperCase() : '' }},
                              {{ !!crew ? crew.first_name.toUpperCase() : '' }} {{ crew.middle_name ? crew.middle_name.substring(0, 1) : '' }}.
                            </option>
                          </select>
                          <span v-if="errors.crew_id"
                                class="text-danger font-weight-bold">{{ errors.crew_id[0] }}</span>
                        </td>
                      </tr>
                      <!-- MA-8c: on a NEW accident report the injury/illness details, cost and files are recorded in
                           the KIDS v2 Medical Report and copied here. The row is shown for an added crew only, and
                           never names KIDS v2 (user, 2026-10-08). Once the crew has a Medical Report, its number
                           opens it like the row's Visit Medical Report button, and the copied details below are
                           shown read-only; the files stay in the Medical Report (user, 2026-10-12). -->
                      <tr v-if="isKidsV2Medical && toEditPersonnel">
                        <td>Medical Report</td>
                        <td class="py-2" data-field="kids-v2-medical-report">
                          <template v-if="kidsV2MedicalReportOf(personnelRecord)">
                            Recorded in Medical Report
                            <button type="button" class="btn btn-link p-0 border-0 align-baseline font-weight-bold"
                                    style="font-size: inherit; line-height: inherit;" title="Open the medical report"
                                    @click="openMedicalReportFromCrewWindow">{{ kidsV2MedicalReportOf(personnelRecord).number || '' }}</button>
                            <template v-if="kidsV2MedicalReportOf(personnelRecord).status"> ({{ String(kidsV2MedicalReportOf(personnelRecord).status).toUpperCase() }})</template>
                            <div v-if="kidsV2MedicalReportOf(personnelRecord).synced_at" class="small text-muted" data-field="kids-v2-synced-at">
                              Details below last copied from the Medical Report: {{ formatCopiedAt(kidsV2MedicalReportOf(personnelRecord).synced_at) }}
                            </div>
                          </template>
                          <template v-else>
                            Not yet recorded.
                          </template>
                        </td>
                      </tr>
                      <!-- NEW accident report, a crew with a Medical Report: the details copied from it, as plain
                           text rather than disabled fields - they are changed in the Medical Report (user, 2026-10-12). -->
                      <template v-if="isKidsV2Medical && toEditPersonnel && kidsV2MedicalReportOf(personnelRecord)">
                        <tr v-for="row in crewWindowCopiedRows" :key="row.key" :data-field="'copied-' + row.key">
                          <td class="align-top py-1">{{ row.label }}</td>
                          <td class="py-1" :class="{ 'text-muted': row.value === '—' }" style="white-space: pre-wrap;">{{ row.value }}</td>
                        </tr>
                      </template>
                      <template v-if="!isKidsV2Medical">
                      <tr>
                        <td>Cost</td>
                        <td>
                          <div class="form-inline">
                            <div class="form-group mr-2">
                              <input type="number" required class="form-control form-control-sm" id="loss_sched_day"
                                     min="0"
                                     step="0.01"
                                     :disabled="toEditPersonnel && readOnly"
                                     v-model="personnelRecord.personnel_costs"
                                     placeholder="Enter personnel cost">
                            </div>
                            <div class="form-group">
                              <select name="" class="form-control form-control-sm mb-1 text-uppercase"
                                      :disabled="toEditPersonnel && readOnly"
                                      v-model="personnelRecord.currency_id">
                                <option :value="null">--- SELECT CURRENCY ---</option>
                                <option v-for="currency in currencies" :key="currency.id" :value="currency.id">
                                  {{ currency.code }}
                                </option>
                              </select>
                            </div>
                          </div>
                        </td>
                      </tr>
                      <tr>
                        <td>Cost Detail</td>
                        <td width="100%"><textarea rows="5"
                                                   :disabled="toEditPersonnel && readOnly"
                                                   class="form-control form-control-sm mb-1 pre-wrap-txt"
                                                   v-model="personnelRecord.lost_details"></textarea>
                        </td>
                      </tr>
                      <tr>
                        <td>Medical Type</td>
                        <td width="100%">
                          <select name="" class="form-control form-control-sm mb-1 text-uppercase"
                                  :disabled="toEditPersonnel && readOnly"
                                  v-model="personnelRecord.medical_type_id">
                            <option :value="null">--- SELECT MEDICAL TYPE ---</option>
                            <option v-for="medicalType in medicalTypeKeys" :key="medicalType.id"
                                    :value="medicalType.id">
                              {{ medicalType.name }}
                            </option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td>Extent of {{ entity }}</td>
                        <td width="100%">
                          <select name="" class="form-control form-control-sm mb-1 text-uppercase"
                                  :disabled="toEditPersonnel && readOnly"
                                  v-model="personnelRecord.medical_severity_id">
                            <option :value="null">--- SELECT EXTENT OF {{ entity }} ---</option>
                            <option v-for="severity in medicalSeverityKeys" :key="severity.id" :value="severity.id">
                              {{ severity.name }} {{ severity.code ? `(${severity.code})` : '' }}
                            </option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td>Complaint</td>
                        <td width="100%"><textarea rows="5" class="form-control form-control-sm mb-1 pre-wrap-txt"
                                                   :disabled="toEditPersonnel && readOnly"
                                                   v-model="personnelRecord.complaint"></textarea>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ entity }}</td>
                        <td width="100%">
                          <multi-select-custom
                            :disabled="toEditPersonnel && readOnly"
                            id="ailments"
                            :items="ailmentKey" :entity="entity"
                            @doneSelected="setAilments"
                            :selected="personnelRecord.ailment_id">
                          </multi-select-custom>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ entity }} Parts</td>
                        <td width="100%">
                          <multi-select-custom
                            id="ailmentParts"
                            :disabled="toEditPersonnel && readOnly"
                            :items="ailmentPartKeys" entity="INJURED PARTS"
                            @doneSelected="setAilmentParts"
                            :selected="personnelRecord.ailment_part_id">
                          </multi-select-custom>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ entity }} Treatment</td>
                        <td width="100%">
                          <select name="" class="form-control form-control-sm mb-1 text-uppercase"
                                  :disabled="toEditPersonnel && readOnly"
                                  v-model="personnelRecord.medical_treatment_id">
                            <option :value="null">--- SELECT {{ entity }} TREATMENT ---</option>
                            <option v-for="treatment in medicalTreatmentKeys" :key="treatment.id" :value="treatment.id">
                              {{ treatment.name }}
                            </option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ entity }} Reason</td>
                        <td width="100%">
                          <select name="" class="form-control form-control-sm mb-1 text-uppercase"
                                  :disabled="toEditPersonnel && readOnly"
                                  v-model="personnelRecord.ailment_reason_id">
                            <option :value="null">--- {{ entity }} REASON ---</option>
                            <option v-for="reason in ailmentReasonKeys" :key="reason.id" :value="reason.id">
                              {{ reason.name }}
                            </option>
                          </select>
                        </td>
                      </tr>
                      <tr>
                        <td>Details of {{ entity }}</td>
                        <td width="100%"><textarea :disabled="toEditPersonnel && readOnly" rows="5"
                                                   class="form-control form-control-sm mb-1 pre-wrap-txt"
                                                   v-model="personnelRecord.ailment_details"></textarea>
                        </td>
                      </tr>
                      <tr>
                        <td>{{ entity }} Files</td>
                        <td width="100%">
                          <template v-if="toEditPersonnel && readOnly">
                            <template v-if="attachments.length">
                              <div class="row">
                                <template v-for="attachment in attachments">
                                  <div class="col-4">
                                    <other-comp v-if="!attachment.isImage"
                                                @viewOther="viewPersonnelAttachment"
                                                @deleteOther="removePersonnelAttachment"
                                                :attachment="attachment"></other-comp>
                                    <image-comp v-else @initDownload="downloadPersonnelAttachment"
                                                @initView="viewPersonnelAttachment"
                                                @initDelete="removePersonnelAttachment"
                                                :image-info="attachment">
                                    </image-comp>
                                  </div>
                                </template>
                              </div>
                            </template>
                          </template>
                          <template v-else>
                            <input type="file"
                                   accept="image/*,.pdf,.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.xlsx,.xls,.csv"
                                   name="attachments" id="attachments" multiple>
                          </template>

                        </td>
                      </tr>
                      </template>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="tab-pane fade" id="nav-HullMachinery" role="tabpanel" aria-labelledby="nav-HullMachinery-tab">
          <!--       LOSS HULL  ///////////////////////////////////////////////////////////////////////////////////// -->
          <table class="w-100">
            <tr>

              <td style="width: 30%">
                <h6 class="font-weight-bold">Hull and Machinery</h6>
              </td>
              <td v-if="toEdit">
                <div class="form-inline">
                  <div class="form-group mb-2 mr-5">
                    <select name="" class="form-control form-control-sm mb-1 text-uppercase"
                            v-model="lossDetails.hm_status">
                      <option value="1">N/A</option>
                      <option value="2">Occurred</option>
                    </select>
                  </div>
                </div>
              </td>
              <!--          <td v-else>{{ accidentIncidentReport.loss_hull_cost }} USD</td>-->
            </tr>

            <!--       LOSS HULL  ///////////////////////////////////////////////////////////////////////////////////// -->
            <!--          v-if="lossDetails.loss_hull_status == 2"-->
            <tr v-if="lossDetails.hm_status == 2">
              <template v-if="toEdit">
                <td style="width: 30%">Cost</td>
                <td>
                  <div class="form-inline">
                    <div class="form-group mb-2 mr-2">
                      <input type="number" min="0" step="0.01" class="form-control form-control-sm" id="loss_sched_day"
                             placeholder="Enter hull cost"
                             v-model="lossDetails.hm_cost">
                    </div>
                    <div class="form-group mx-sm-3 mb-2">
                      <select name="" class="form-control form-control-sm mb-1 text-uppercase"
                              v-model="lossDetails.hm_currency_id">
                        <option :value="null">--- SELECT CURRENCY ---</option>
                        <option v-for="currency in currencies" :key="currency.id" :value="currency.id">
                          {{ currency.code }}
                        </option>
                      </select>
                    </div>

                  </div>
                </td>
              </template>
            </tr>


            <tr v-if="!toEdit">
              <td style="width: 30%">Cost</td>
              <td>
                {{ accidentIncidentReport.loss.hm_cost ? accidentIncidentReport.loss.hm_cost : '0.00' }}
                {{ accidentIncidentReport.loss.hmCurrency ? accidentIncidentReport.loss.hmCurrency : 'N/A' }}
              </td>

            </tr>

            <tr v-if="lossDetails.hm_status == 2">
              <template v-if="toEdit">
                <td style="width: 30%">Cost Detail</td>
                <td>
                  <div>
            <textarea v-model="lossDetails.hm_cost_details" rows="5"
                      class="form-control form-control-sm pre-wrap-txt"></textarea>
                  </div>
                </td>
              </template>
            </tr>

            <tr v-if="!toEdit">
              <td style="width: 30%">Cost Detail</td>
              <td>
                <p class="pre-wrap-txt textarea-display-card mb-1">
                  {{
                    accidentIncidentReport.loss.hm_cost_details ? accidentIncidentReport.loss.hm_cost_details : 'N/A'
                  }}
                </p>
              </td>
            </tr>
            <tr>
              <td colspan="100%">
                <h6 class="font-weight-bold">Machinery / Equipment</h6>
              </td>
            </tr>
            <tr>
              <td>Equipment Manufacturer</td>
              <td class="text-uppercase">
            <textarea rows="2" class="form-control form-control-sm mb-1 pre-wrap-txt"
                      v-model="lossDetails.hm_equipment_manufacturer"
                      v-if="toEdit"
            ></textarea>
                <span class="pre-wrap-txt" v-else>{{ accidentIncidentReport.loss.hm_equipment_manufacturer }}</span>
              </td>
            </tr>
            <tr>
              <td>Equipment Model</td>
              <td class="text-uppercase">
            <textarea rows="2" class="form-control form-control-sm mb-1 pre-wrap-txt"
                      v-model="lossDetails.hm_equipment_model"
                      v-if="toEdit"
            ></textarea>
                <span class="pre-wrap-txt" v-else>{{ accidentIncidentReport.loss.hm_equipment_model }}</span>
              </td>
            </tr>
            <tr>
              <td>Related Part Numbers</td>
              <td class="text-uppercase">
            <textarea rows="2" class="form-control form-control-sm mb-1 pre-wrap-txt"
                      v-model="lossDetails.hm_part_number"
                      v-if="toEdit"
            ></textarea>
                <span class="pre-wrap-txt" v-else>{{ accidentIncidentReport.loss.hm_part_number }}</span>
              </td>
            </tr>

          </table>
          <!--       LOSS HULL  ///////////////////////////////////////////////////////////////////////////////////// -->
        </div>
        <div class="tab-pane fade" id="nav-CargoDamage" role="tabpanel" aria-labelledby="nav-CargoDamage-tab">
          <!--       CARGO DAMAGE ///////////////////////////////////////////////////////////////////////////////////// -->
          <table class="w-100">
            <tr>
              <td style="width: 30%">
                <h6 class="font-weight-bold">Cargo Damage</h6>
              </td>
              <td v-if="toEdit">
                <div class="form-inline">
                  <div class="form-group mb-2 mr-5">
                    <select name="" class="form-control form-control-sm mb-1 text-uppercase"
                            v-model="lossDetails.cd_status">
                      <option value="1">N/A</option>
                      <option value="2">Occurred</option>
                    </select>
                  </div>
                </div>
              </td>
            </tr>

            <tr v-if="lossDetails.cd_status == 2">
              <template v-if="toEdit">
                <td style="width: 30%">Cost</td>
                <td>
                  <div class="form-inline">
                    <div class="form-group mb-2 mr-2">
                      <input type="number" min="0" step="0.01" class="form-control form-control-sm" id="loss_sched_day"
                             placeholder="Enter hull cost"
                             v-model="lossDetails.cd_cost">
                    </div>
                    <div class="form-group mx-sm-3 mb-2">
                      <select name="" class="form-control form-control-sm mb-1 text-uppercase"
                              v-model="lossDetails.cd_currency_id">
                        <option :value="null">--- SELECT CURRENCY ---</option>
                        <option v-for="currency in currencies" :key="currency.id" :value="currency.id">
                          {{ currency.code }}
                        </option>
                      </select>
                    </div>
                  </div>
                </td>
              </template>
            </tr>

            <tr v-if="!toEdit">
              <td style="width: 30%">Cost</td>
              <td>
                {{ accidentIncidentReport.loss.cd_cost ? accidentIncidentReport.loss.cd_cost : '0.00' }}
                {{ accidentIncidentReport.loss.cdCurrency ? accidentIncidentReport.loss.cdCurrency : 'N/A' }}
              </td>
            </tr>


            <!--        <tr>-->
            <!--          <td style="width: 30%">Cost</td>-->
            <!--          <td v-if="toEdit">-->
            <!--            <input type="number" step=".01" class="form-control form-control-sm" v-model="lossDetails.loss_cargo_cost"/>-->
            <!--          </td>-->
            <!--          <td v-else>{{ accidentIncidentReport.loss_cargo_cost }} USD</td>-->
            <!--        </tr>-->

            <tr v-if="lossDetails.cd_status == 2">
              <template v-if="toEdit">
                <td style="width: 30%">Cost Detail</td>
                <td>
                  <div>
            <textarea v-model="lossDetails.cd_cost_details" rows="5"
                      class="form-control form-control-sm pre-wrap-txt"></textarea>
                  </div>
                </td>
              </template>
            </tr>

            <tr v-if="!toEdit">
              <td style="width: 30%">Cost Detail</td>
              <td>
                <p class="pre-wrap-txt textarea-display-card mb-1">
                  {{
                    accidentIncidentReport.loss.cd_cost_details ? accidentIncidentReport.loss.cd_cost_details : 'N/A'
                  }}
                </p>
              </td>
            </tr>


            <!--        <tr>-->
            <!--          <td>Cost Detail</td>-->
            <!--          <td v-if="toEdit">-->
            <!--            <textarea v-model="lossDetails.loss_cargo_detail" rows="5"-->
            <!--                      class="form-control form-control-sm pre-wrap-txt"></textarea>-->
            <!--          </td>-->
            <!--          <td class="pre-wrap-txt" v-else>{{ accidentIncidentReport.loss_cargo_detail }}</td>-->
            <!--        </tr>-->


          </table>
          <!--       CARGO DAMAGE ///////////////////////////////////////////////////////////////////////////////////// -->
        </div>
        <div class="tab-pane fade" id="nav-Environmental" role="tabpanel" aria-labelledby="nav-Environmental-tab">
          <!--       ENVIRONMENTAL  ///////////////////////////////////////////////////////////////////////////////////// -->
          <table class="w-100">
            <tr>
              <td style="width: 30%">
                <h6 class="font-weight-bold">Environmental</h6>
              </td>
              <td v-if="toEdit">
                <div class="form-inline">
                  <div class="form-group mb-2 mr-5">
                    <select name="" class="form-control form-control-sm mb-1 text-uppercase"
                            v-model="lossDetails.e_status">
                      <option value="1">N/A</option>
                      <option value="2">Occurred</option>
                    </select>
                  </div>
                </div>
              </td>
            </tr>


            <tr v-if="lossDetails.e_status == 2">
              <template v-if="toEdit">
                <td style="width: 30%">Cost</td>
                <td>
                  <div class="form-inline">
                    <div class="form-group mb-2 mr-2">
                      <input type="number" min="0" step="0.01" class="form-control form-control-sm" id="loss_sched_day"
                             placeholder="Enter environmental cost"
                             v-model="lossDetails.e_cost">
                    </div>
                    <div class="form-group mx-sm-3 mb-2">
                      <select name="" class="form-control form-control-sm mb-1 text-uppercase"
                              v-model="lossDetails.e_currency_id">
                        <option :value="null">--- SELECT CURRENCY ---</option>
                        <option v-for="currency in currencies" :key="currency.id" :value="currency.id">
                          {{ currency.code }}
                        </option>
                      </select>
                    </div>

                  </div>
                </td>
              </template>
            </tr>

            <tr v-if="!toEdit">
              <td style="width: 30%">Cost</td>
              <td>
                {{ accidentIncidentReport.loss.e_cost ? accidentIncidentReport.loss.e_cost : '0.00' }}
                {{ accidentIncidentReport.loss.eCurrency ? accidentIncidentReport.loss.eCurrency : 'N/A' }}
              </td>
            </tr>


            <tr v-if="lossDetails.e_status == 2">
              <template v-if="toEdit">
                <td style="width: 30%">Cost Detail</td>
                <td>
                  <div>
            <textarea v-model="lossDetails.e_cost_details" rows="5"
                      class="form-control form-control-sm pre-wrap-txt"></textarea>
                  </div>
                </td>
              </template>
            </tr>

            <tr v-if="!toEdit">
              <td style="width: 30%">Cost Detail</td>
              <td>
                <p class="pre-wrap-txt textarea-display-card mb-1">
                  {{ accidentIncidentReport.loss.e_cost_details ? accidentIncidentReport.loss.e_cost_details : 'N/A' }}
                </p>
              </td>
            </tr>

          </table>
          <!--       ENVIRONMENTAL  ///////////////////////////////////////////////////////////////////////////////////// -->

        </div>
        <div class="tab-pane fade" id="nav-ThirdParty" role="tabpanel" aria-labelledby="nav-ThirdParty-tab">
          <!--       THIRD PARTY  ///////////////////////////////////////////////////////////////////////////////////// -->
          <table class="w-100">
            <tr>
              <td style="width: 30%">
                <h6 class="font-weight-bold">Third Party</h6>
              </td>
              <td v-if="toEdit">
                <div class="form-inline">
                  <div class="form-group mb-2 mr-5">
                    <select name="" class="form-control form-control-sm mb-1 text-uppercase"
                            v-model="lossDetails.tp_status">
                      <option value="1">N/A</option>
                      <option value="2">Occurred</option>
                    </select>
                  </div>
                </div>
              </td>
            </tr>


            <tr v-if="lossDetails.tp_status == 2">
              <template v-if="toEdit">
                <td style="width: 30%">Cost</td>
                <td>
                  <div class="form-inline">
                    <div class="form-group mb-2 mr-2">
                      <input type="number" class="form-control form-control-sm" id="loss_sched_day"
                             min="0" step="0.01"
                             placeholder="Enter Third Party cost"
                             v-model="lossDetails.tp_cost">
                    </div>
                    <div class="form-group mx-sm-3 mb-2">
                      <select name="" class="form-control form-control-sm mb-1 text-uppercase"
                              v-model="lossDetails.tp_currency_id">
                        <option :value="null">--- SELECT CURRENCY ---</option>
                        <option v-for="currency in currencies" :key="currency.id" :value="currency.id">
                          {{ currency.code }}
                        </option>
                      </select>
                    </div>

                  </div>
                </td>
              </template>
            </tr>

            <tr v-if="!toEdit">
              <td style="width: 30%">Cost</td>
              <td>
                {{ accidentIncidentReport.loss.tp_cost ? accidentIncidentReport.loss.tp_cost : '0.00' }}
                {{ accidentIncidentReport.loss.tpCurrency ? accidentIncidentReport.loss.tpCurrency : 'N/A' }}
              </td>
            </tr>


            <tr v-if="lossDetails.tp_status == 2">
              <template v-if="toEdit">
                <td style="width: 30%">Cost Detail</td>
                <td>
                  <div>
            <textarea v-model="lossDetails.tp_cost_details" rows="5"
                      class="form-control form-control-sm pre-wrap-txt"></textarea>
                  </div>
                </td>
              </template>
            </tr>

            <tr v-if="!toEdit">
              <td style="width: 30%">Cost Detail</td>
              <td>
                <p class="pre-wrap-txt textarea-display-card mb-1">
                  {{
                    accidentIncidentReport.loss.tp_cost_details ? accidentIncidentReport.loss.tp_cost_details : 'N/A'
                  }}
                </p>
              </td>
            </tr>

          </table>
          <!--       THIRD PARTY  ///////////////////////////////////////////////////////////////////////////////////// -->
        </div>
      </div>

    </form>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import MultiSelectCustom from "@/components/MultiSelectCustom";
import ImageComp from "@/components/elements/ImageComp";
import OtherComp from "@/components/elements/OtherComp";
import {FileService} from "@/services/FileService";
import {permissionMixin} from "@/mixins/permissionMixins";
import {DataService} from "@/services/DataService";

const {ReportService} = require('../../../services/ReportService')
const {AlertService} = require('../../../services/AlertService')

export default {
  name: 'Loss',
  components: {MultiSelectCustom, ImageComp, OtherComp},
  data() {
    return {
      hullMachinerySelection: 1,
      currentIndex: null,
      lossDetails: {},
      personnelList: [],
      linkableReports: [],
      linkableSearch: '',
      linkableLoading: false,
      linkableMessage: '',
      reportId: this.$route.params.id,
      toEdit: false,
      toEditPersonnel: false,
      attachments: [],
      errors: {},
      readOnly: true,
      personnelRecord: {
        crew_id: null,
        complaint: '',
        loss_details: '',
        personnel_costs: 0,
        currency_id: null,
        ailment_id: [],
        ailment_reason_id: null,
        ailment_part_id: [],
        ailment_details: '',
        medical_type_id: null,
        medical_treatment_id: null,
        medical_severity_id: null,
        last_name: '',
        first_name: '',
        middle_name: '',
      }
    }
  },
  mixins:[permissionMixin],
  methods: {
    ...mapActions([
      'getAccidentIncidentReport',
      'getCurrencyKeys',
      'getReports',
      'updateAccidentIncidentLoss',
      'deletePersonnel',
      'getMedicalTypeKeys',
      'getMedicalSeverityKeys',
      'getAilmentKeys',
      'getAilmentPartKeys',
      'getMedicalTreamentKeys',
      'getAilmentReasonKeys',
      'addLossPersonnel',
      'linkMedicalReport',
      'getCrewKeys',
      'generateSSOToken'
    ]),
    async cancel() {
      if (this.hasChanges === false) {
        this.toEdit = false;
      } else {
        if (await AlertService.cancelAlert()) {
          this.toEdit = false;
          this.resetPersonnels()
        }
      }
    },

    setTotalHours(day = 0, hours = 0, min = 0) {
      const totalHoursInDays= day * 24
      const totalHoursInMins= (min / 60)

      return Number((totalHoursInDays + hours) + totalHoursInMins).toFixed(2)
    },

    formatToMoney(amount) {
      return Number(amount).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
    },
    async addLossDetailsReport() {
      if (await AlertService.confirmUpdateAlert()) {
        this.lossDetails.id = this.reportId
        this.lossDetails.personnels = this.personnelList.filter(personnel => !!personnel.crew_id);
        const result = await this.updateAccidentIncidentLoss(this.lossDetails);
        if (result) {
          AlertService.successAlert('Updating Loss Action Details', 'UPDATE')
          await this.getAccidentIncidentReport(this.reportId)
          this.toEdit = false;
        }
      }
    },
    async editValues() {
      this.toEdit = true
      if (this.toEdit) {
        this.lossDetails = Object.assign({}, this.accidentIncidentReport.loss)
        // this.personnelList = this.accidentIncidentReport.loss.personnel ? this.accidentIncidentReport.loss.personnel : this.personnelList
      }

    },
    resetPersonnelRecord() {
      this.toEditPersonnel = false
      this.readOnly = true
      this.currentIndex = null;
      this.attachments = [];
      this.errors = false;
      this.personnelRecord = {
        crew_id: null,
        complaint: '',
        loss_details: '',
        personnel_costs: 0,
        currency_id: null,
        ailment_id: [],
        ailment_reason_id: null,
        ailment_part_id: [],
        ailment_details: '',
        medical_type_id: null,
        medical_treatment_id: null,
        medical_severity_id: null,
        last_name: '',
        first_name: '',
        middle_name: '',
      }
    },
    async requestNewCrewKeys() {
      let crewListParam = {
        onboard_from: this.accidentIncidentReport.event_date,
        onboard_to: this.accidentIncidentReport.event_date,
        vesselName: this.accidentIncidentReport.vessel,
      }
      await this.getCrewKeys(crewListParam);
    },
    async addInjuredPersonnel() {
      if (await AlertService.confirmCreateAlert('Do you want to add this crew?')) {
        swal.fire({
          title: 'Adding New Crew Loss Info, please wait...',
        });
        swal.showLoading();
        const form = this.setFormData(this.personnelRecord);
        const response = await this.addLossPersonnel(form);
        if (typeof response === 'boolean' && response) {
          await this.requestNewCrewKeys();
          this.resetPersonnelRecord();
          $('#crewPersonnel').modal('hide');
          await this.formatPersonnelLists(this.accidentIncidentReport.loss)
          swal.close();
          AlertService.successAlert('Crew has been added successfully','ADD INJURED PERSONNEL');

        } else {
          if (response.errors) {
            this.errors = response.errors;
          }
        }
      }
    },
    setFormData(formData) {
      const form = new FormData();
      form.append('accident_incident_id', this.$route.params.id);
      Object.keys(formData).forEach((key) => {
        if (Array.isArray(formData[key]) && formData[key].length) {
          formData[key].forEach(item => {
            form.append(`${key}[]`, item);
          })
        } else {
          form.append(key, formData[key])
        }

      })
      const files = document.getElementById('attachments');
      // MA-8c: the Files row isn't shown on NEW accident reports, so the input may be missing.
      if (files && files.files && files.files.length > 0) {
        Array.prototype.forEach.call(files.files, (file) => {
          form.append(`attachments[]`, file)
        });
      }
      return form;
    },
    async updateInjuredPersonnel() {
      if (await AlertService.confirmUpdateAlert('Do you want to update this crew?')) {
        swal.fire({
          title: 'Updating Crew Loss Info, please wait...',
        });
        swal.showLoading();
        const form = this.setFormData(this.personnelRecord);
        const response = await this.addLossPersonnel(form);
        if (typeof response === 'boolean' && response) {
          await this.requestNewCrewKeys();
          this.resetPersonnelRecord();
          $('#crewPersonnel').modal('hide');
          await this.formatPersonnelLists(this.accidentIncidentReport.loss)
          swal.close();
          AlertService.successAlert('Crew has been updated successfully','UPDATE INJURED PERSONNEL');
        } else {
          if (response.errors) {
            this.errors = response.errors;
          }
        }
      }
    },
    async formatPersonnelLists(loss) {
      this.personnelList = [];
      const data = Object.assign([], JSON.parse(JSON.stringify(this.crewKeys)));
      if (!data) {
        return;
      }
      if (loss.hasOwnProperty('personnel') && loss.personnel.length) {
        loss.personnel.forEach(personnel => {
          // CMS down: the onboard list is empty, so keep the row with the name KIDS stores.
          const person = data.find(crew => crew.id === personnel.crew_id) || {
            id: personnel.crew_id,
            last_name: personnel.last_name,
            first_name: personnel.first_name,
            middle_name: personnel.middle_name,
          }
          this.personnelList.push({
            crew_id: person.id,
            active: person.active,
            last_name: person.last_name ?? '',
            first_name: person.first_name ?? '',
            middle_name: person.middle_name ?? '',
            age: person.age ?? null,
            rank: person.rank ?? '',
            manning: person.manning ?? '',
            embarkationDate: person.embarkationDate ?? '',
            duration: person.duration ?? '',
            nationality: person.nationality ?? '',
            id: personnel.id ?? null,
            ailment_reason_id: personnel.ailment_reason_id ?? null,
            medical_severity_id: personnel.medical_severity_id ?? null,
            medical_treatment_id: personnel.medical_treatment_id ?? null,
            medical_type_id: personnel.medical_type_id ?? null,
            currency_id: personnel.currency_id ?? null,
            air_loss_id: personnel.air_loss_id ?? null,
            ailment_id: personnel.ailment_id ?? [],
            ailment_part_id: personnel.ailment_part_id ?? [],
            complaint: personnel.complaint ?? '',
            lost_details: personnel.lost_details ?? '',
            personnel_costs: personnel.personnel_costs ?? '',
            ailment_details: personnel.ailment_details ?? '',
            // {id, report_number, status}|null - see
            // BUILD_REQUEST_Backend_AccidentIncident_MedicalLink.md, B1.
            linked_medical_report: personnel.linked_medical_report ?? null,
            // MA-8c: {id, number, status, synced_at}|null - the KIDS v2 Medical Report this row's
            // details were copied from (written by KIDS v2 on NEW accident reports).
            kids_v2_medical_report: personnel.kids_v2_medical_report ?? null,
            // Declared upfront (not added later) so it's reactive from the
            // start - guards the Visit Medical Report button against
            // a double-click firing the whole SSO handoff twice on a slow
            // link (see FIX_REQUEST...CreateMedicalReportLoaderDelay.md).
            medicalReportLoading: false
          })
        })
      }
    },

    changeCrewName(event, index = null) {;
      const data = Object.values(this.personnelList)
      if (index) {
        data.splice(index, 1);
      }
      const filteredCrew = data.filter(crew => crew.crew_id === this.personnelRecord.crew_id)
      if (filteredCrew.length > 0) {
        AlertService.errorAlert(`${filteredCrew[0].last_name}, ${filteredCrew[0].first_name} ${filteredCrew[0].middle_name} already exists in the list`, 'SELECT CREW')
        this.personnelRecord.crew_id = null;
        this.personnelRecord.last_name = '';
        this.personnelRecord.first_name = '';
        this.personnelRecord.middle_name = '';
      } else {
        var crewIndex = Object.values(this.crewKeys).findIndex(crew => crew.id == event.target.value)
        this.personnelRecord.last_name = this?.crewKeys[crewIndex]?.last_name ?? '';
        this.personnelRecord.first_name = this?.crewKeys[crewIndex]?.first_name ?? '';
        this.personnelRecord.middle_name = this?.crewKeys[crewIndex]?.middle_name ?? '';
      }
    },

    async viewPersonnel(personnel, index) {
      this.currentIndex = index;
      this.toEditPersonnel = true;
      this.personnelRecord = Object.assign({}, personnel)
      // MA-8c: files of a NEW accident report's crews are kept in the KIDS v2 Medical Report.
      this.attachments = this.isKidsV2Medical ? [] : await ReportService.getPersonnelAttachments({air_loss_personnel_id: personnel.id});
    },

    async downloadPersonnelAttachment(attachment) {
      swal.fire({
        title: 'Please wait',
      });
      swal.showLoading();
      const response = await ReportService.getPersonnelAttachment({id: attachment.id});
      if (response) {
        await FileService.downloadDocument(response, attachment)
        swal.close();
      }
    },

    async viewPersonnelAttachment(attachment) {
      swal.fire({
        title: 'Please wait',
      });
      swal.showLoading();
      const response = await ReportService.getPersonnelAttachment({id: attachment.id});
      if (response) {
        if (attachment.extension === 'pdf' || attachment.mime_type.includes("image")) {
          await FileService.viewDocument(response, attachment)
        } else {
          await FileService.downloadDocument(response, attachment);
        }
        swal.close();
      }
    },

    async removePersonnelAttachment(attachment) {
      if (await AlertService.confirmDeleteAlert(null, 'Are you sure you want to delete this attachment?', 'Yes, delete attachment')) {
        swal.fire({
          title: 'Deleting attachment please wait...',
        });
        swal.showLoading();
        const response = await ReportService.deletePersonnelAttachment(attachment)
        if (response.success) {
          swal.close();
          this.attachments = this.attachments.filter(attachmentInfo => attachmentInfo.id !== attachment.id);
          await AlertService.successAlert('ATTACHMENT DELETED SUCCESSFULLY', 'REMOVE ATTACHMENT');
        }
      }
    },


    // NEW accident report, "Add Crew" (user 2026-11-05): the Medical Reports that can be linked here.
    async loadLinkableMedicalReports() {
      if (!this.isKidsV2Medical) return;
      this.linkableSearch = '';
      this.linkableMessage = '';
      this.linkableLoading = true;
      const answer = await ReportService.getLinkableMedicalReports({reportId: this.$route.params.id});
      this.linkableReports = answer.data ?? [];
      this.linkableMessage = answer.message ?? '';
      this.linkableLoading = false;
    },
    async selectMedicalReport(report) {
      if (await AlertService.confirmCreateAlert(`Do you want to add ${report.crew_name} with Medical Report ${report.report_number}?`)) {
        swal.fire({title: 'Adding the crew, please wait...'});
        swal.showLoading();
        const answer = await this.linkMedicalReport({reportId: this.$route.params.id, medicalReportId: report.id});
        await this.formatPersonnelLists(this.accidentIncidentReport.loss);
        swal.close();
        if (answer.success) {
          $('#crewPersonnel').modal('hide');
          AlertService.successAlert('Crew has been added successfully', 'ADD CREW');
        } else {
          AlertService.errorAlert(answer.message, 'ADD CREW');
          await this.loadLinkableMedicalReports();
        }
      }
    },
    async removePersonnel(id) {
      const person = this.personnelList.find(row => row.id === id);
      const confirmed = this.isKidsV2Medical && person && this.hasKidsV2MedicalReport(person)
        ? await AlertService.confirmDeleteAlert('REMOVE THIS CREW?', `Medical Report ${this.kidsV2MedicalReportOf(person).number} stays and can be selected again.`, 'Yes, remove it!')
        : await AlertService.confirmDeleteAlert('Do you want to remove this personnel from the list ?');
      if (confirmed) {
        const response = await this.deletePersonnel({id: id})
        if (response === true) {
          await this.formatPersonnelLists(this.accidentIncidentReport.loss)
          AlertService.successAlert('Personnel removed successfully', 'REMOVE PERSONNEL');
        } else {
          AlertService.errorAlert(response || 'Personnel remove encounter an error', 'REMOVE PERSONNEL');
        }
      }
    },
    // Visit Medical Report for one personnel row. A Medical Report is created on its own page and selected in
    // "Add Crew" (user 2026-11-05), so a row only ever visits one.
    //
    // One browser tab per crew row: a second click switches to the tab this
    // row already opened instead of opening another copy of the same page.
    // window.open('', name) hands back that tab untouched (no reload, so a
    // half-filled form keeps what was typed) or, when there is none, a new
    // blank one - opened here, still inside the click, so popup blockers let
    // it through - which openMedicalReportSso() sends to the medical report
    // page once the steps below are done.
    async onMedicalReportClick(person) {
      const report = this.kidsV2MedicalReportOf(person)
      if (!report || person.medicalReportLoading) return // nothing to visit, or already running - ignore a double click

      const tab = window.open('', this.medicalReportTabName(person))
      if (tab && this.isMedicalReportTabInUse(tab)) {
        tab.focus()
        return
      }
      this.showMedicalReportTabConnecting(tab)
      let opened = false
      person.medicalReportLoading = true

      try {
        const { default: Swal } = await import('sweetalert2')

        Swal.fire({
          title: 'Connecting to the Medical Report module',
          html: 'Preparing to redirect you to the medical report page…',
          allowOutsideClick: false,
          allowEscapeKey: false,
          showConfirmButton: false,
          didOpen: () => Swal.showLoading(),
        })
        opened = await this.openMedicalReportSso('medical-reports-detail', {
          medical_report_id: report.id
        }, tab)
      } finally {
        person.medicalReportLoading = false
        // Nothing was sent to the new tab (the error popup shows on this page
        // instead): close it rather than leave a blank tab behind.
        if (tab && !opened && !tab.closed) tab.close()
      }
    },

    async openMedicalReportSso(redirectPathName, extraParams, targetWindow = null) {
      return await this.generateSSOToken({
        redirect_path_name: redirectPathName,
        user_id: this.user.id,
        ...extraParams,
        targetWindow
      })
    },

    // The browser tab of one crew row of this accident report (see onMedicalReportClick).
    medicalReportTabName(person) {
      return `kids-medical-report-${this.accidentIncidentReport.id}-${person.id || ('crew-' + person.crew_id)}`
    },
    // A tab already showing the medical report module: its address can't be
    // read (another site) or isn't the blank page window.open('', name) gives
    // a new tab.
    isMedicalReportTabInUse(tab) {
      try {
        return tab.location.href !== 'about:blank'
      } catch (e) {
        return true
      }
    },
    // The new tab says what it's waiting for, instead of staying blank.
    showMedicalReportTabConnecting(tab) {
      if (!tab) return
      try {
        tab.document.title = 'Connecting to the Medical Report module'
        tab.document.body.style.cssText = 'font-family: sans-serif; margin: 2rem; color: #495057;'
        tab.document.body.textContent = 'Connecting to the Medical Report module…'
      } catch (e) {
        // Not writable here - the tab just stays blank until the page loads.
      }
    },

    // MA-8c helpers for NEW accident reports (is_kids_v2_medical).
    kidsV2MedicalReportOf(person) {
      if (!person) return null;
      if (person.kids_v2_medical_report) return person.kids_v2_medical_report;
      const linked = person.linked_medical_report;
      return linked ? { id: linked.id, number: linked.report_number, status: linked.status } : null;
    },
    hasKidsV2MedicalReport(person) {
      return !!this.kidsV2MedicalReportOf(person);
    },
    // The crew window's report number: the same as that row's Visit Medical Report button (and its tab).
    openMedicalReportFromCrewWindow() {
      const person = this.personnelList[this.currentIndex];
      if (person) this.onMedicalReportClick(person);
    },
    // "12 October 2026 13:17", in the viewer's own time.
    formatCopiedAt(value) {
      const date = new Date(value);
      if (isNaN(date.getTime())) return '';
      const pad = (n) => String(n).padStart(2, '0');
      return `${date.getDate()} ${date.toLocaleString('en-US', { month: 'long' })} ${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
    },
    setAilments(event) {
      this.personnelRecord.ailment_id = event.selected
    },
    setAilmentParts(event) {
      this.personnelRecord.ailment_part_id = event.selected
    },
    setDelaySchedForCheckingChanges(key) {
      if (this.accidentIncidentReport.loss[key] === '') {
        if (this.lossDetails[key] === 0 || this.lossDetails[key] === '') {
          return '';
        } else {
          return parseInt(this.lossDetails[key])
        }
      } else {
        return this.lossDetails[key] !== '' ? parseInt(this.lossDetails[key]) : this.lossDetails[key];
      }
    }
  },


  async created() {
    await this.getMedicalTypeKeys();
    await this.getMedicalSeverityKeys();
    await this.getAilmentKeys();
    await this.getAilmentPartKeys();
    await this.getMedicalTreamentKeys();
    await this.getAilmentReasonKeys();
    this.formatPersonnelLists(this.accidentIncidentReport.loss)
  },
  async beforeRouteLeave(to, from, next) {
    if (this.hasChanges === true) {
      if (await AlertService.cancelChanges()) {
        next();
      } else {
        next(false);
      }

    } else {
      next();
    }
  },
  computed: {
    ...mapGetters([
      'accidentIncidentReport',
      'currencies',
      'reports',
      'crewKeys',
      'medicalTypeKeys',
      'medicalSeverityKeys',
      'ailmentKeys',
      'ailmentPartKeys',
      'medicalTreatmentKeys',
      'ailmentReasonKeys',
      'user'
    ]),
    // MA-8c: true on a NEW accident report (created at or after KIDS v1's KIDS_V2_MEDICAL_REPORT_START_AT) - its
    // crews' injury/illness details are recorded in the KIDS v2 Medical Report. Decided by v1's server.
    isKidsV2Medical() {
      return !!(this.accidentIncidentReport && this.accidentIncidentReport.is_kids_v2_medical === true);
    },
    // "Add Crew": the search is by Medical Report no. (user 2026-11-05).
    filteredLinkableReports() {
      const search = this.linkableSearch.trim().toUpperCase();
      return this.linkableReports.filter(report => report.report_number.toUpperCase().includes(search));
    },
    // The crew window's name as text (NEW accident report), worded like the crew dropdown's options.
    crewWindowCrewLabel() {
      const record = this.personnelRecord || {};
      // crewKeys is kept as an object (CrewModule: Object.assign({}, ...)), not an array.
      const crews = Array.isArray(this.crewKeys) ? this.crewKeys : Object.values(this.crewKeys || {});
      const crew = crews.find(c => c && record.crew_id != null && String(c.id) === String(record.crew_id)) || record;
      const middle = crew.middle_name ? ` ${crew.middle_name.substring(0, 1).toUpperCase()}.` : '';
      const name = `${(crew.last_name || '').toUpperCase()}, ${(crew.first_name || '').toUpperCase()}${middle}`;
      return crew.rank ? `${String(crew.rank).toUpperCase()} - ${name}` : name;
    },
    // The details copied from the Medical Report, as label/text rows for the crew window (NEW accident report).
    // A KIDS v1 list value shows its name (as the old dropdowns did), and an empty value shows "—".
    crewWindowCopiedRows() {
      const record = this.personnelRecord || {};
      // The key lists may be arrays or objects (crewKeys is an object): read either.
      const list = (value) => (Array.isArray(value) ? value : Object.values(value || {}));
      const same = (a, b) => a !== null && a !== undefined && b !== null && b !== undefined && String(a) === String(b);
      const text = (value) => (value === null || value === undefined || String(value).trim() === '' ? '—' : String(value).trim());
      const keyName = (keys, id) => {
        const key = list(keys).find(k => k && same(k.id, id));
        return key ? key.name : null;
      };
      const severity = list(this.medicalSeverityKeys).find(k => k && same(k.id, record.medical_severity_id));
      const names = (keys, ids) => (ids || []).map(id => keyName(keys, id)).filter(Boolean).join(', ');
      const cost = () => {
        if (record.personnel_costs === null || record.personnel_costs === undefined || record.personnel_costs === '') return '—';
        const amount = Number(record.personnel_costs).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        const currency = record.currency || (list(this.currencies).find(c => c && same(c.id, record.currency_id)) || {}).code || '';
        return `${amount} ${currency}`.trim();
      };
      return [
        { key: 'cost', label: 'Cost', value: cost() },
        { key: 'cost-detail', label: 'Cost Detail', value: text(record.lost_details) },
        { key: 'medical-type', label: 'Medical Type', value: text(keyName(this.medicalTypeKeys, record.medical_type_id) || record.medicalType) },
        { key: 'extent', label: `Extent of ${this.entity}`, value: text(severity ? `${severity.name}${severity.code ? ` (${severity.code})` : ''}` : record.medicalSeverity) },
        { key: 'complaint', label: 'Complaint', value: text(record.complaint) },
        { key: 'ailments', label: this.entity, value: text(names(this.ailmentKeys, record.ailment_id)) },
        { key: 'parts', label: `${this.entity} Parts`, value: text(names(this.ailmentPartKeys, record.ailment_part_id)) },
        { key: 'treatment', label: `${this.entity} Treatment`, value: text(keyName(this.medicalTreatmentKeys, record.medical_treatment_id) || record.medicalTreatment) },
        { key: 'reason', label: `${this.entity} Reason`, value: text(keyName(this.ailmentReasonKeys, record.ailment_reason_id) || record.ailmentReason) },
        { key: 'details', label: `Details of ${this.entity}`, value: text(record.ailment_details) },
        { key: 'files', label: `${this.entity} Files`, value: 'Kept in the Medical Report.' },
      ];
    },
    ailmentKey() {
      if (this.personnelRecord.medical_type_id) {
        return this.ailmentKeys.filter(ailment => ailment.medical_type_id === this.personnelRecord.medical_type_id)
      }
      return this.ailmentKeys;
    },
    entity() {
      if (this.personnelRecord.medical_type_id) {
        const medicalType = this.medicalTypeKeys.filter(medicalType => medicalType.id === this.personnelRecord.medical_type_id)
        return medicalType[0].name
      }
      return this.medicalTypeKeys.map(medKey => {
        return medKey.name.charAt(0).toUpperCase() + medKey.name.slice(1)
      }).slice(0, 2).join(' / ');
    },
    hasChanges() {
      if (this.toEdit === false) {
        return false;
      }

      let editedData = {
        is_delay_schedule         : this.lossDetails.is_delay_schedule,
        hm_status                 : this.lossDetails.hm_status !== '' ? parseInt(this.lossDetails.hm_status) : '',
        hm_cost                   : this.lossDetails.hm_cost,
        hm_currency_id            : this.lossDetails.hm_currency_id !== null ? parseInt(this.lossDetails.hm_currency_id) : null,
        hm_cost_details           : this.lossDetails.hm_cost_details,
        hm_equipment_manufacturer : this.lossDetails.hm_equipment_manufacturer,
        hm_equipment_model        : this.lossDetails.hm_equipment_model,
        hm_part_number            : this.lossDetails.hm_part_number,
        cd_status                 : this.lossDetails.cd_status !== '' ? parseInt(this.lossDetails.cd_status) : '',
        cd_cost                   : this.lossDetails.cd_cost,
        cd_currency_id            : this.lossDetails.cd_currency_id !== null ? parseInt(this.lossDetails.cd_currency_id) : null,
        cd_cost_details           : this.lossDetails.cd_cost_details,
        e_status                  : this.lossDetails.e_status !== '' ? parseInt(this.lossDetails.e_status) : '',
        e_cost                    : this.lossDetails.e_cost,
        e_currency_id             : this.lossDetails.e_currency_id !== null ? parseInt(this.lossDetails.e_currency_id) : null,
        e_cost_details            : this.lossDetails.e_cost_details,
        tp_status                 : this.lossDetails.tp_status !== '' ? parseInt(this.lossDetails.tp_status) : '',
        tp_cost                   : this.lossDetails.tp_cost,
        tp_currency_id            : this.lossDetails.tp_currency_id !== null ? parseInt(this.lossDetails.tp_currency_id) : null,
        tp_cost_details           : this.lossDetails.tp_cost_details,
      };

      editedData.delay_sched_day = this.setDelaySchedForCheckingChanges('delay_sched_day');
      editedData.delay_sched_hour = this.setDelaySchedForCheckingChanges('delay_sched_hour');
      editedData.delay_sched_minute = this.setDelaySchedForCheckingChanges('delay_sched_minute');

      if (this.accidentIncidentReport.loss.delay_sched_remarks === 'N/A') {
        editedData.delay_sched_remarks = this.lossDetails.delay_sched_remarks === '' ? 'N/A' : this.lossDetails.delay_sched_remarks;
      } else {
        editedData.delay_sched_remarks = this.lossDetails.delay_sched_remarks;
      }

      return DataService.checkIfChanged(this.accidentIncidentReport.loss, editedData);
    }
  },
  watch: {
    'lossDetails.loss_hull_status'() {
      if (this.lossDetails.loss_hull_status == 1) {
        this.lossDetails.loss_hull_cost = ''
        this.lossDetails.loss_hull_currency = ''
        this.lossDetails.loss_hull_detail = ''
      }
    },

    'lossDetails.loss_cargo_status'() {
      if (this.lossDetails.loss_cargo_status == 1) {
        this.lossDetails.loss_cargo_cost = ''
        this.lossDetails.loss_cargo_currency = ''
        this.lossDetails.loss_cargo_detail = ''
      }
    },

    'lossDetails.loss_environmental_status'() {
      if (this.lossDetails.loss_environmental_status == 1) {
        this.lossDetails.loss_environmental_cost = ''
        this.lossDetails.loss_environmental_currency = ''
        this.lossDetails.loss_environmental_detail = ''
      }
    },

    'lossDetails.loss_third_party_status'() {
      if (this.lossDetails.loss_third_party_status == 1) {
        this.lossDetails.loss_third_party_cost = ''
        this.lossDetails.loss_third_party_currency = ''
        this.lossDetails.loss_third_party_detail = ''
      }
    },

    'lossDetails.is_delay_schedule'(){
      if (!this.lossDetails.is_delay_schedule) {
        this.lossDetails.delay_sched_day = 0
        this.lossDetails.delay_sched_hour = 0
        this.lossDetails.delay_sched_minute = 0
        this.lossDetails.delay_sched_remarks = ''
      }
    }
  },

}
</script>

<style scoped lang="scss">
.modal:nth-of-type(even) {
  z-index: 1052 !important;
}

.bg-highlight-red {
  background-color: #ffb7b7;
}

.modal-backdrop.show:nth-of-type(even) {
  z-index: 1051 !important;
}

.nav > .nav-link {
  padding: 8px 16px;
  border-top: 0;
  border-left: 0;
  border-right: 0;
  color: #435464;
  margin-bottom: -1;
}

.nav > .active, .nav > .nav-link:hover {
  border-bottom: 2px solid #d3313c;
  color: #d3313c;
}

.nav-tabs {
  border-bottom: 2px solid #dee2e6;
}

table td {
  padding: 2px;
}

.inactive-crew {
  background-color: #e2e3e5;
}
</style>
